/* LAMPS — loader, cursor, fade-in observer */
(function () {

  // Custom cursor
  const cursor = document.querySelector(".lamps-cursor");
  if (cursor && window.matchMedia("(hover: hover)").matches) {
    let cx = 0, cy = 0, tx = 0, ty = 0;
    document.addEventListener("mousemove", (e) => { tx = e.clientX; ty = e.clientY; });
    function loop() {
      cx += (tx - cx) * 0.18;
      cy += (ty - cy) * 0.18;
      cursor.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    }
    loop();
    document.querySelectorAll("a, button, .button, [role=button]").forEach((el) => {
      el.addEventListener("mouseenter", () => cursor.classList.add("is-lg"));
      el.addEventListener("mouseleave", () => cursor.classList.remove("is-lg"));
    });
  }

  // Fade reveals
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll(".lamps-fade").forEach((el) => io.observe(el));
})();
